import React, { useEffect, useState } from 'react';
import { ITire } from 'components/SearchBlock/TireSearch/TireSearchBlock';
import TireDataSelect from 'components/SearchBlock/TireSearch/SelectFields/TireDataSelect';

interface IProps {
    selectedTire?: ITire;
    setSelectedTire: (tire?: ITire) => void;
    placeholder: string;
    options: Array<string>;
}

const WidthSelect = (props: IProps) => {
    const { selectedTire, setSelectedTire, placeholder, options } = props;
    const [width, setWidth] = useState<string>();

    useEffect(() => {
        setSelectedTire({ ...selectedTire, width });
    }, [width]);

    return (
        <TireDataSelect
            placeholder={placeholder}
            options={options}
            attribute={selectedTire?.width}
            setAttribute={setWidth}
        />
    );
};

export default WidthSelect;
